import React from 'react';
import './IntroAnimation.css';

const IntroAnimation = ({ onAnimationEnd }) => {

    const handleAnimationEnd = (e) => {

        // Mark the animation as shown in the sessionStorage
        sessionStorage.setItem("animationShown", "true");

        setTimeout(() => {
            onAnimationEnd();
        }, 2000);
    };

    return (
        <div className="intro-animation-overlay" onAnimationEnd={handleAnimationEnd}>
            <div className="intro-animation-content">
                <span className="intro-animation-item">
                    <img src="/images/logo_intro.png" alt="Logo" className="intro-animation-logo" />
                </span>
                {"Schedio + Partners".split('').map((char, index) => (
                    // Stagger animation delay for each character
                    <span
                        key={index}
                        className="intro-animation-item intro-animation-letter"
                    >
                        {char}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default IntroAnimation;
